<template>
    <div class="purple-title">
        <h2>{{ title }}</h2>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped>
.purple-title{
    background: #826d8a;
    padding: 10px 20px;
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.purple-title h2{
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}
</style>